<template>
  <v-dialog persistent v-model="dialog" max-width="500px">
    <template v-slot:activator="{ on }">
      <v-btn depressed color="secondary" small v-on="on">{{$t("newBlueprint")}}</v-btn>
    </template>
    <v-card>
      <v-tabs fixed-tabs>
        <v-tab ripple>{{$t("newBlueprint")}}</v-tab>
        <v-tab-item>
          <v-card flat>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  outlined
                  dense
                  :rules="rules($t('name'))"
                  required
                  counter="512"
                  v-model="name"
                  :placeholder="$t('firstFloor')"
                  v-bind:label="$t('name')"
                ></v-text-field>
                <v-text-field
                  outlined
                  dense
                  required
                  v-model="description"
                  v-bind:label="$t('description')"
                ></v-text-field>
                <v-menu transition="scale-transition" origin="right top"
                  offset-y
                  ref="menu1"
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  full-width
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      dense
                      readonly
                      v-model="deadline"
                      v-bind:label="$t('deadline')"
                      persistent-hint
                      prepend-icon="event"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="deadline" no-title></v-date-picker>
                </v-menu>
                <v-select
                  :menu-props="{ bottom: true, offsetY: true }"
                  outlined
                  dense
                  v-model="installers"
                  :items="allInstallers"
                  v-bind:label="$t('installer')"
                  chips
                  item-value="id"
                  item-text="fullName"
                  multiple
                  return-object
                >
                  <!-- <template slot="selection" slot-scope="data">
                      <template>{{ data.item.Name }} {{ data.item.Firstname }}</template>
                    </template>
                    <template slot="item" slot-scope="data">
                      <template>{{ data.item.Name }} {{ data.item.Firstname }}</template>
                  </template>-->
                </v-select>
              </v-form>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close">{{$t("close")}}</v-btn>
        <v-btn color="primary" text @click="save">{{$t("save")}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import uuid from "uuid";
export default {
  name: "AddBlueprint",
  data: () => ({
    menu: false,
    valid: false,
    dialog: false,
    name: "",
    description: "",
    markerName: "",
    installers: [],
    deadline: null,
    allInstallers: []
  }),
  methods: {
    close() {
      this.dialog = false;
    },
    async getAllInstallers() {
      try {
        let res = await this.$http.getInstallers();
        this.allInstallers = res.data
      } catch (err) {
        console.log(err);
      }
    },
    rules(property = this.$t("name")) {
      let rules = [
        v => !!v || `${property} ${this.$t("required")}`,
        v => (v && v.length <= 512) || ""
      ];
      return rules;
    },
    save() {
      if (this.$refs.form.validate()) {
        const newBlueprint = {
          id: uuid.v4(),
          name: this.name,
          description: this.description,
          installers: this.installers,
          deadline: this.deadline,
          createdBy: localStorage.getItem("user"),
          modifiedBy: localStorage.getItem("user"),
          buildingComponentId: this.$route.params.id
        };
        this.$emit("add-blueprint", newBlueprint);
        this.close();
      }
    }
  },
  mounted() {
    this.getAllInstallers();
  }
};
</script>




// WEBPACK FOOTER //
// src/components/pages/Blueprints/AddBlueprint.vue